const config = {
	region: {
		prefix: "",
		name: "Москва"
	},
	restApiHost: "http://194.87.98.162/api/v1.1",
	imageApiHost: "http://194.87.98.162/mania/public"
}

export {config}


	
